import React, { useState } from "react";
import {
  Heading,
  Spacer,
  ColorPicker,
  PasswordStrength,
  PageLoader
} from "src/components";
import { Colors } from "src/types";
import { theme } from "src/config";
import styled from "styled-components";
import Box from "react-raster";
import { useTranslation } from "react-i18next";
import { ProgressSlider } from "src/components";

const StyledPasswordStrengthBox = styled(Box)`
  border: 1px solid #ccc;
  border-radius: 0%;
  padding: 1rem;
`;

export const ExtraSection = () => {
  const [color, setColor] = useState("#aabbcc");
  const [password, setPassword] = useState("#0abbcc");
  const [passwordRepeat, setPasswordRepeat] = useState("#0abbcc");
  const { t, i18n } = useTranslation();

  const [progress, setProgress] = React.useState<number>(0);
  const updateProgress  = React.useCallback((val: number) => {
    setProgress(val);
  }, []);


  return (
    <Box>
      <Heading weight="normal" type="h3" color="black">
        Extras
      </Heading>
      <Box>
        <hr />
      </Box>
      <Box>
        <Box display="flex" flexDirection="row">
          <PageLoader />
          <Spacer size="large" />
          <ColorPicker
            value={color}
            onClose={setColor}
            label={t("select_color")}
          />
        </Box>
        <ProgressSlider 
              label    = "Progress"
              value    = {progress}
              onChange = {updateProgress}
              step     = {5}
            />
        <StyledPasswordStrengthBox>
          <PasswordStrength
            password={password}
            passwordRepeat={passwordRepeat}
            onValidate={(valid) => {}}
          />
        </StyledPasswordStrengthBox>
      </Box>
    </Box>
  );
};
